import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-br from-orange-500 via-pink-500 to-pink-600 pt-12 pb-20 md:pt-20 md:pb-32 px-4" data-id="element-87">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-88">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-white z-10 order-2 md:order-1" data-id="element-89">
          <div className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-sm font-semibold mb-6 border border-white/30" data-id="element-90">
            🇺🇸 Para mujeres hispanas en USA
          </div>

          <h1 className="text-4xl md:text-6xl font-black leading-tight mb-6 tracking-tight" data-id="element-91">
            Habla inglés aunque <br className="hidden md:block" data-id="element-92" />
            <span className="relative inline-block" data-id="element-93">
              <span className="relative z-10" data-id="element-94">te dé pena</span>
              <span className="absolute bottom-2 left-0 w-full h-3 bg-yellow-400 -rotate-1 z-0 opacity-80" data-id="element-95"></span>
            </span>
            <br data-id="element-96" />
            (en 7 días)
          </h1>

          <p className="text-xl md:text-2xl font-medium text-white/90 mb-8 leading-relaxed" data-id="element-97">
            <span className="bg-yellow-400/90 text-gray-900 px-2 py-0.5 rounded-md box-decoration-clone" data-id="element-98">
              Guiones + práctica
            </span>{' '}
            para hablar aunque tengas acento.
          </p>

          <div className="space-y-6 text-lg text-white/90 mb-10 max-w-lg" data-id="element-99">
            <p data-id="element-100">
              Hay un tipo de silencio que no es "timidez". Es el silencio que
              aparece cuando te hablan en inglés… y tu cabeza se queda vacía.
            </p>
            <p data-id="element-101">
              Este PDF no es otro curso. Es un kit de frases listas + un plan de
              10 minutos al día para que dejes de congelarte.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-102">
            <Button size="lg" className="group" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-103">
              Quiero el Kit 🔥
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-104" />
            </Button>
            <p className="text-sm text-white/70 mt-3 sm:mt-0 sm:ml-4 flex items-center" data-id="element-105">
              *Descarga inmediata
            </p>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        rotate: 2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative z-10 order-1 md:order-2 flex justify-center" data-id="element-106">
          <div className="relative w-full max-w-[400px] md:max-w-[500px]" data-id="element-107">
            {/* Glow effect behind image */}
            <div className="absolute inset-0 bg-white/20 blur-3xl rounded-full transform scale-90" data-id="element-108"></div>

            <img src="https://cdn.magicpatterns.com/uploads/wHspBtCVCXFiL8NFRzxRBJ/heylloyd-image-1771023853175.png" alt="Inglés Sin Pena PDF en tablet" className="relative z-10 w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-109" />

            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 md:bottom-10 md:-right-10 bg-white text-gray-900 p-4 rounded-2xl shadow-xl border-2 border-yellow-400 transform rotate-3 z-20 max-w-[160px]" data-id="element-110">
              <p className="font-bold text-sm leading-tight" data-id="element-111">
                ⚡️ Incluye 12 frases de rescate
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-112">
        <div className="absolute -top-20 -left-20 w-64 h-64 bg-yellow-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" data-id="element-113"></div>
        <div className="absolute top-40 -right-20 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" data-id="element-114"></div>
      </div>
    </section>;
}